import { useDispatch, useSelector } from "react-redux";

import TabSelect, { TabItem } from "@/components/tabSelect";
import Section from "@/components/ui/section";
import { RootState } from "@/store";
import { setCatchmentSettingsTemp } from "@/store/slice/spatialSlice";
import { CatchmentType, ECatchmentType } from "@/types/spatial";

import CatchmentByRadius from "./catchmentByRadius";
import CatchmentByRoadAccess from "./catchmentByRoadAccess";

const CATCHMENT_TYPE: TabItem[] = [
  {
    label: "By Radius",
    value: ECatchmentType.BY_RADIUS
  },
  {
    label: "By Road Access",
    value: ECatchmentType.BY_ROAD
  }
];

const CatchmentTypeSection = () => {
  const dispatch = useDispatch();
  const { catchmentSettingsTemp } = useSelector(
    (state: RootState) => state.spatial
  );

  return (
    <div className="flex flex-col px-4 gap-2">
      <Section label="Catchment Type">
        <TabSelect
          className="h-[32px]"
          buttonClassName="text-xs h-[24px]"
          wrapperListClassName="w-full"
          tabList={CATCHMENT_TYPE}
          selected={catchmentSettingsTemp.catchmentType}
          onSelect={(data) =>
            dispatch(
              setCatchmentSettingsTemp({ catchmentType: data as CatchmentType })
            )
          }
        />
      </Section>
      {catchmentSettingsTemp.catchmentType === ECatchmentType.BY_RADIUS && (
        <CatchmentByRadius />
      )}
      {catchmentSettingsTemp.catchmentType === ECatchmentType.BY_ROAD && (
        <CatchmentByRoadAccess />
      )}
    </div>
  );
};

export default CatchmentTypeSection;
